import { Button } from '@mui/material';
import { ACTION_STATUS } from '~/components/Admin/ResourceTable';
import { admin } from '~/components/Admin/AdminDialog/AdminDialog.style';

type TProps = {
  handleClose: () => void;
  status: ACTION_STATUS;
  handleSubmit: () => void;
  acceptButtonText: string;
  disabled?: boolean;
};
export const AdminDialogActions = ({
  handleClose,
  status,
  handleSubmit,
  acceptButtonText,
  disabled,
}: TProps) => {
  return (
    <admin.DialogActions>
      <Button color="inherit" variant="outlined" onClick={handleClose}>
        取消
      </Button>
      <Button
        disabled={disabled}
        color={status === ACTION_STATUS.BATCH_OFF ? 'success' : 'info'}
        variant="contained"
        onClick={handleSubmit}
      >
        {acceptButtonText}
      </Button>
    </admin.DialogActions>
  );
};
